import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui } from "@ryde/theme";

export const LiveMapMapDisplayedSummaryStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-map-displayed-summary",
  },
)`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: ${blueGreyMui._500};

  .live-map-displayed-prefix {
    font-weight: 400;
  }

  .live-map-displayed-stat {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-weight: 500;
  }

  .live-map-displayed-stat-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: ${greyMui._700};
  }

  .live-map-displayed-stat-icon--mui {
    font-size: 16px;
  }
`;
